export default __webpack_public_path__ + "static/media/icons8-deadline.3c2e5d29.svg";